function initAccordeon() {
    const accordionItems = document.querySelectorAll('.accordeon-item');

    accordionItems.forEach(item => {
        const trigger = item.querySelector('.accordeon-item__trigger');

        trigger.addEventListener('click', () => {
            const isOpen = item.classList.toggle('is-active');
            trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
    });
}